import { ApiDataAccess, ApiResourceLocation } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { REQUEST_TOKEN_PATH, RESET_PASSWORD_PATH } from '../password.api';
import { ResetPassword } from '../data/reset-password';
import { UserValidationInfo } from '../data/user-validation';

@Injectable()
export class PasswordRepository {
  private service = inject(ApiDataAccess);

  async requestToken(value: UserValidationInfo): Promise<UserValidationInfo> {
    const location: ApiResourceLocation = { path: REQUEST_TOKEN_PATH };
    return await this.service.create(location, value);
  }

  async resetPassword(value: ResetPassword): Promise<unknown> {
    const location: ApiResourceLocation = { path: RESET_PASSWORD_PATH };
    const { password, username, token } = value;
    return await this.service.create(location, { password, username, token });
  }
}
